export default {
  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "Non hai crediti IA sufficienti per generare questo report. Contatta il tuo amministratore.",
      REPORT_ACCESS_DENIED: "Questo report IA non è abilitato per il tuo account.",
      NOT_FOUND: "Impossibile trovare il report richiesto.",
      INVALID_INPUT: "Alcuni dei dati forniti non sono validi. Controllali e riprova.",
      INVALID_GEOMETRY: "L'area selezionata non è valida. Modifica la geofence e riprova.",
    },
    usersByStatus: "Utenti per Stato",
    usersByGender: "Utenti da Genere",
    gen: "Genere",
    gender: "Grafico di genere",
    male: "Maschio",
    female: "Femmina",
    other: "Altri",
    unspefied: "Non specificato",
    byCountry: "Per Paese",
    avgPriceFarmer: "Prezzo di vendita medio da tutti gli agricoltori",
    avgPrice: "Prezzo medio di vendita per agricoltore",
    selectYear: "Seleziona anno",
    total: "Totale",
    farmerName: "Nome del coltivatore",
    farmerProdChart: "Produzione agricola Grafico",
    production: "Produzione",
    byProduction: "Per la produzione",
    byName: "Per nome",
    descending: "Discussione",
    ascending: "Finanziamenti",
    buyingStationProdChart: "Grafico di produzione della stazione",
    buyingStation: "Comprare la stazione",
    buyingStationName: "Nome della stazione di acquisto",
    dryMilling: "Mulino a secco",
    dryMillingName: "Nome della fresatura a secco",
    dryMillingProdChart: "Grafico di produzione di fresatura a secco",
    view: "Vista",
    date: "Data",
    reports: "Relazioni",
    today: "Oggi",
    week: "Rassegna",
    month: "Mese",
    year: "Anno",
    all: "Tutti",
    selectCrop: "Seleziona il raccolto",
    selectRegion: "Seleziona la Regione",
    selectProvinceState: "Seleziona Provincia/Stato",
    downloadPdfReport: "Scarica PDF Relazione",
    export: "Esportazione",
    search: "Ricerca",
    yield: "Rendimento",
    avgAreaPerUnit: "Area media in {unit}",
    yieldPerUnit: "Resa/{unit}",
    averageSellingPriceByAllFarmers:
      "Prezzo di vendita medio da tutti gli agricoltori",
    averageSellingPricePerFarmer: "Prezzo medio di vendita per agricoltore",
    pricePaid: "Prezzo pagato",
    pests: {
      pestReport: "Relazione Pest",
      filterByCrops: "Filtra per Crops",
      pestStatistics: "Statistiche del Pest",
      regions: "Regioni",
      occurrences: "Occurrence",
      pestChart: "Grafico dei parassiti",
      totalArea: "Superficie totale",
      pestName: "Nome della lista",
      region: "Regione",
      crop: "Colture",
      listByLand: "Elenco per Land",
    },
    regions: {
      regionalReport: "Relazione regionale",
      listByFarm: "Elenco delle aziende agricole",
      listByFarmers: "Elenco degli agricoltori",
      listByYield: "Elenco di Yield",
      regionalStatistics: "Statistiche regionali",
      countries: "Paesi",
      states: "Stati/Provincia",
      city: "Città/Town/Village",
      farmsIn: "Agriturismi in Puglia",
      regionalChart: "Grafico regionale",
      farms: "Aziende agricole",
      regionName: "Nome della Regione",
      farmers: "Agricoltori",
      yield: "Rendimento/Acre",
    },
    dashboard: {
      topCharts: "Grafico superiore",
      regions: "Regioni",
      noOfFarms: "Numero di aziende agricole/regione",
      provinces: "Stati membri",
      landArea: "LandArea",
      avgFarmerLand: "Avg. Terreno agricolo",
      viewAll: "Vedi tutto",
      crops: "Colture",
      plantedAreaCrop: "Area vegetale/Croppo",
      plantedArea: "Area vegetale",
      avgYieldCrop: "Avg. Rendimento/Crop",
      averageYield: "Rendimento medio",
      yieldChart: "Grafico di rendimento",
      selectFarm: "Seleziona Agriturismo",
      soilQuality: "Qualità del suolo",
      pests: "Pests",
      occurrences: "eventi",
      equipments: "Attrezzature",
      goalAchievedChart: "Obiettivi raggiunti Grafico",
      soilValues: "Valori del suolo",
      soil: "Soil",
      showReport: "Mostra i rapporti su Dashboard",
      selectAll: "Seleziona tutto",
    },
    weight: "Peso",
    quality: "Qualità",
    price: "Prezzo",

    yieldPrediction: "Previsione del Rendimento",
    listOfReports: "Elenco dei Rapporti",
    noYieldPredictionReportsFound: "Nessun rapporto di previsione del rendimento trovato",
    loadingYieldPredictions: "Caricamento delle previsioni di rendimento...",
    createNewReport: "Crea Nuovo Rapporto",

    howToUseReport: "Come usare il Rapporto?",
    viewGuide: "Visualizza la Guida",
    cancel: "Annulla",
    generateReport: "Genera Rapporto",
    selectFarmGeofence: "Seleziona Geofence dell'Azienda Agricola",
    selectFarmGeofenceDescription: "Seleziona un'azienda agricola registrata, disegna il confine della tua azienda agricola sulla mappa o inserisci una posizione per iniziare ad analizzare la previsione di rendimento della tua area agricola.",
    point: "Punto",
    geofence: "Geofence",
    selectFarmZone: "Seleziona Azienda/Zona",
    select: "Seleziona",
    latitude: "Latitudine",
    longitude: "Longitudine",
    uploadGeojsonFile: "Carica File GeoJSON",
    uploadGeojsonFileDescription: "Seleziona un file GeoJSON con la tua geofence dal tuo computer e caricalo. Verrà caricata solo una geofence alla volta, anche se il file ne contiene più di una.",
    selectAFile: "Seleziona un File",
    hideAdvanced: "Nascondi Avanzato",
    showAdvancedVariation: "Mostra Variazione Avanzata",
    uploadHistoricalYieldDataDescription: "Carica i dati storici di rendimento della tua azienda agricola",
    showInstructions: "Mostra Istruzioni",
    downloadTemplate: "Scarica Modello",
    chooseFile: "Scegli File",
    noFileSelected: "Nessun file selezionato",
    yieldPredictionGuide: "Guida alla Previsione del Rendimento",
    forecastedYields: "Rendimenti Previsti",
    farmArea: "Area dell'Azienda Agricola",
    yieldForecasts: "Previsioni di Rendimento",
    graph: "Grafico",
    actualYields: "Rendimenti Effettivi",
    predictedFutureYields: "Rendimenti Futuri Previsti",
    averageYields: "Rendimenti Medi",
    yieldTrendsGraph: "Grafico delle Tendenze di Rendimento",
    step1: "Passo 1",
    step2: "Passo 2",
    step3: "Passo 3",
    step4: "Passo 4",
    satelliteMapView: "Vista della Mappa Satellitare",
    selectYourFarm: "Seleziona la tua azienda agricola dal menu a discesa (se già registrata).",
    selectCropType: "Seleziona un tipo di coltura:",
    clickGenerateReport: "Fai clic su 'Genera Rapporto' per visualizzare il tuo rapporto di previsione del rendimento.",
    howToGenerateReport: "Come Generare un Rapporto?",
    howToInterpretReport: "Come Interpretare il Rapporto?",
    tip: "Suggerimento",

    disclaimer: "Avvertenza",
    disclaimer1: "È impossibile prevedere con precisione il meteo per un'intera stagione. Ad esempio, grandine o inondazioni possono verificarsi in qualsiasi momento, influenzando significativamente le previsioni di rendimento.",
    disclaimer2: "I rendimenti dipendono fortemente dalle pratiche di gestione dell'agricoltore. Ad esempio, l'applicazione tempestiva di pesticidi o un'adeguata irrigazione possono influenzare notevolmente il rendimento finale.",
    disclaimer3: "Ci sono altri fattori che possono contribuire a errori significativi nelle previsioni di rendimento basate sull'IA.",
    startYear: "Anno di Inizio",
    endYear: "Anno di Fine",
    back: "Indietro",
    deleteReport: "Elimina Rapporto",
    confirmDeleteReport: "Sei sicuro di voler eliminare questo rapporto di previsione del rendimento? Questa azione non può essere annullata e tutti i dati associati verranno rimossi permanentemente.",
    deleteConfirmation: "Conferma Eliminazione",
    download: "Scarica",
    report: "Rapporto",
    dateOfReport: "Data del Rapporto",
    farm: "Azienda Agricola",
    location: "Posizione",
    zone: "Zona",
    crop: "Coltura",
    farmers: "Agricoltori",
    yieldPerAcre: "Rendimento/Acro",
    yieldPerHectare: "Rendimento/Ettaro",
    predictionModel: "Modello di Previsione",
    accuracy: "Precisione (R²)",
    confidence: "Confidenza",
    producer: "Produttore",
    reportDeletedSuccessfully: "Rapporto eliminato con successo",
    failedToDeleteReport: "Impossibile eliminare il rapporto",
    enterHere: "Inserisci qui",
    hectares: "ettari",
    whatIsYieldReportTitle: "Cos'è un Rapporto di Previsione del Rendimento?",
    yieldReportDescription: "Il Rapporto di Previsione del Rendimento ti aiuta a stimare i rendimenti delle colture per la tua azienda agricola utilizzando dati storici, dati satellitari e modelli predittivi basati sull'IA. Il rapporto ti fornisce una stima di quanto raccolto potresti ottenere nell'anno in corso e negli anni a venire. Il rapporto fornisce informazioni sui rendimenti effettivi, sui rendimenti futuri previsti e sui rendimenti medi, consentendoti di ottimizzare le tue operazioni agricole e di pianificare in anticipo.",
    creatingYourReportEasy: "Creare il tuo rapporto è facile:",
    selectYourFarmDescription: "Il confine apparirà sulla mappa. Oppure, disegna manualmente il confine della tua azienda agricola (poligono o punto) sulla mappa se non è ancora registrata. Puoi anche cercare digitando Latitudine e Longitudine per ingrandire una posizione.",
    selectCropTypeDescription: "Scegli la coltura che vuoi analizzare dal menu a discesa.",
    clickGenerateReportDescription: "per visualizzare il tuo rapporto di previsione del rendimento.",
    interpretReportIntro: "Una volta generato il rapporto, vedrai le previsioni di rendimento per l'anno in corso e quello successivo. Un grafico mostra le tendenze di rendimento della tua azienda agricola con tre linee:",
    blueLineActualYields: "Linea Blu (Rendimenti Effettivi):",
    blueLineDescription: "Rappresenta i risultati reali del raccolto delle stagioni precedenti sulla tua azienda agricola. Questo ti aiuta a comprendere le tendenze delle prestazioni passate nel tempo.",
    redLinePredictedYields: "Linea Rossa (Rendimenti Futuri Previsti):",
    redLineDescription: "Mostra le previsioni basate sull'IA per i rendimenti futuri. Fornisce una stima di ciò che ti puoi aspettare (quanto potresti raccogliere) in base ai dati e alle tendenze attuali.",
    brownLineAverageYields: "Linea Marrone (Rendimenti Medi):",
    brownLineDescription: "Indica il rendimento medio su tutti i dati disponibili per l'azienda agricola. Questa linea funge da punto di riferimento per aiutarti a confrontare i rendimenti storici e previsti con la tendenza generale.",
    highPredictedYieldsLabel: "Rendimenti previsti elevati",
    highPredictedYieldsDescription: "suggeriscono che le pratiche attuali sono efficaci. Mantieni le tue strategie e replicale in altre aree della tua azienda agricola.",
    lowPredictedYieldsLabel: "Rendimenti previsti bassi",
    lowPredictedYieldsDescription: "possono indicare aree di miglioramento, come i calendari di semina, la salute del suolo, l'uso di fertilizzanti, l'irrigazione, la gestione dei parassiti, lo stress idrico o le carenze nutritive, ecc. Indaga e affronta questi problemi precocemente per evitare ulteriori perdite di rendimento.",
    tipDescription: "Puoi salvare, scaricare o eliminare i tuoi rapporti per riferimenti futuri.",
    validationError: "Errore di Convalida",
    pleaseSelectCrop: "Seleziona una coltura",
    pleaseEnterLatLng: "Inserisci latitudine e longitudine o seleziona un punto sulla mappa",
    pleaseDrawGeofence: "Disegna una geofence sulla mappa o carica un file GeoJSON",
    invalidGeojsonFile: "File GeoJSON non valido",
    invalidGeojsonFileDescription: "Assicurati che il file sia in un formato GeoJSON valido.",
    errorReadingFile: "Errore nella lettura del file",
    failedToReadGeojson: "Impossibile leggere il file GeoJSON. Riprova.",
    yieldReportGeneratedSuccessfully: "Rapporto di previsione del rendimento generato con successo",
    failedToGenerateReport: "Impossibile generare il rapporto. Riprova.",
    farmAndFarmId: "Azienda e ID Azienda",
    producerName: "Nome del Produttore",
    failedToLoadReport: "Impossibile caricare il rapporto di previsione del rendimento",
    reportDataNotLoaded: "I dati del rapporto non sono caricati. Attendi e riprova.",
    pdfGeneratedSuccessfully: "PDF generato con successo",
    failedToGeneratePdf: "Impossibile generare il PDF. Riprova.",
    editMap: "Modifica Mappa",
    editMapDescription: "La funzionalità di modifica della mappa sarà implementata qui",
    noForecastDataAvailable: "Nessun dato di previsione disponibile",
    noGraphImageAvailable: "Nessuna immagine del grafico disponibile",
    // Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "Dashboard report IA",
    aiReports: "Report IA",
    dashboardGuide: "Dashboard Guide",
    aiReportBuilders: "AI Report Builders",
    aiInsightsAndAnalytics: "AI Insights and Analytics",
    reportTypeDistribution: "Report Type Distribution",
    reportType: "Report Type",
    reportsGenerated: "Reports Generated",
    recentAiReports: "Recent AI Reports",
    vegetationVigorAnalysis: "Vegetation Vigor Analysis",
    farmProductivityAnalysis: "Farm Productivity Analysis",
    anomaliesDetection: "Anomalies Detection",
    diseaseDetection: "Disease Detection",
    averageVegetationHealth: "Average Vegetation Health",
    diseaseDetectedThisMonth: "Disease Detected this Month",
    anomaliesThisMonth: "Anomalies this Month",
    predictedYieldTrend: "Predicted Yield Trend",
    comingSoon: "Prossimamente",
    reportBuilderComingSoon: "This AI report builder is coming soon.",
    loadingRecentReports: "Loading recent reports…",
    noRecentAiReports: "No recent AI reports found.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    sourceFarmZone: "Azienda / zona",
    sourcePolygon: "Poligono",
    sourceCircle: "Cerchio",
    sourceGeojson: "GeoJSON",
    radiusM: "Raggio (m)",
    drawPolygon: "Disegna poligono",
    drawPolygonHelp: "Fai clic sulla mappa per aggiungere punti.",
    drawCircle: "Disegna cerchio",
    drawCircleHelp: "Fai clic sulla mappa per impostare il centro; imposta il raggio sotto o trascina il cerchio per ridimensionarlo.",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      title: "Analisi della produttività aziendale",
      listOfReports: "Elenco dei report",
      createNewReport: "Crea nuovo report",
      backToDashboard: "Torna alla dashboard",
      generateReport: "Genera report",
      cancel: "Annulla",
      back: "Indietro",
      deleteReport: "Elimina report",
      downloadReport: "Scarica report",
      aiReportGuide: "Guida al report IA",
      viewGuide: "Vedi guida",
      howToUseReport: "Come usare il report?",
      search: "Cerca",
      reportId: "ID report",
      farmAndFarmId: "Azienda e ID azienda",
      producerName: "Nome del produttore",
      dateOfReport: "Data del report",
      status: "Stato",
      statusCompleted: "Completato",
      statusGenerating: "In generazione",
      statusFailed: "Non riuscito",
      location: "Posizione",
      farm: "Azienda",
      zone: "Zona",
      actions: "Azioni",
      view: "Visualizza",
      delete: "Elimina",
      selectFarmGeofence: "Seleziona geofence azienda",
      selectFarmGeofenceHelp: "Seleziona un'azienda registrata, disegna il confine sulla mappa oppure carica un file GeoJSON.",
      selectFarmZone: "Seleziona azienda / zona",
      sourceFarmZone: "Azienda / zona",
      sourcePolygon: "Poligono",
      sourceCircle: "Cerchio",
      sourceGeojson: "GeoJSON",
      radiusM: "Raggio (m)",
      select: "Seleziona",
      uploadGeojsonFile: "Carica file GeoJSON",
      uploadGeojsonHelp: "Seleziona un file GeoJSON con la geofence e caricalo. VerrÃ  caricata una sola geofence alla volta, anche se il file ne contiene diverse.",
      selectAFile: "Seleziona un file",
      drawPolygon: "Disegna poligono",
      drawPolygonHelp: "Fai clic sulla mappa per aggiungere punti.",
      drawCircle: "Disegna cerchio",
      drawCircleHelp: "Fai clic sulla mappa per impostare il centro; imposta il raggio sotto o trascina il cerchio per ridimensionarlo.",
      estimatedComputeCost: "Costo di calcolo stimato",
      totalCreditsRequired: "Crediti totali richiesti",
      creditsComingSoon: "Sistema di crediti in arrivo.",
      reportDetails: "Dettagli del report",
      generating: "Generazione del report...",
      generatingHelp: "Il report è in fase di generazione. Potrebbero volerci alcuni minuti.",
      failed: "Generazione del report non riuscita.",
      reportDescription: "Il report delle zone di produttività analizza la produttività dell'area aziendale in base alle prestazioni storiche e agli indicatori di vegetazione.",
      disclaimerTitle: "AVVISO",
      disclaimer: "Questo report generato da IA Ã¨ pensato come guida. Per una diagnosi accurata e raccomandazioni su misura, consigliamo di consultare un agronomo o un esperto agricolo qualificato.",
      zoneLabels: {
        "Lowest Productivity Zones": "Zone a produttività più bassa",
        "Low Productivity Zones": "Zone a bassa produttività",
        "Moderate Productivity Zones": "Zone a produttività moderata",
        "High Productivity Zones": "Zone ad alta produttività",
        "Highest Productivity Zones": "Zone a produttività più alta",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Aree con la resa delle colture più scarsa che richiedono attenzione o intervento immediato.",
        "Low Productivity Zones": "Aree con resa inferiore alla media che necessitano di miglioramenti.",
        "Moderate Productivity Zones": "Aree con resa moderata che potrebbero necessitare di alcuni aggiustamenti.",
        "High Productivity Zones": "Aree con resa superiore alla media e buon potenziale produttivo.",
        "Highest Productivity Zones": "Aree con resa ottimale e il massimo potenziale produttivo.",
      },
      feedback: "Feedback",
      doYouAgree: "Sei d'accordo con la previsione?",
      agree: "D'accordo",
      disagree: "In disaccordo",
      agreedWithPrediction: "D'accordo con la previsione",
      disagreedWithPrediction: "In disaccordo con la previsione",
      disagreeHelp: "Se non sei d'accordo con questo risultato, fornisci un feedback",
      addFeedback: "Aggiungi feedback",
      feedbackPlaceholder: "Inserisci qui",
      attachmentsOptional: "Allegati (opzionale)",
      attachments: "Allegati",
      download: "Scarica",
      attachmentsHelp: "Trascina qui immagini o video, oppure sfoglia i file. Formati supportati: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleziona i file da caricare",
      orDragAndDrop: "oppure trascina e rilascia qui",
      submit: "Invia",
      feedbackSubmitted: "Feedback inviato correttamente.",
      feedbackAlreadySubmitted: "Il feedback Ã¨ giÃ  stato inviato per questo report.",
      guideTitle: "Guida alle zone di produttività",
      guideStep: "Passo {current} di {total}",
      next: "Avanti",
      close: "Chiudi",
      guideStep1Title: "Cos'è il report delle zone di produttività?",
      guideStep1Body: "Il report delle zone di produttività analizza la produttività delle aree all'interno della zona o azienda e le classifica in zone a resa bassa, moderata e alta.",
      guideStep2Title: "Come generare un report?",
      guideStep2Body: "Creare il report è facile:\n\n1. Seleziona l'azienda dal menu a discesa (se registrata) oppure disegna/carica il confine.\n2. Genera il report e attendi il completamento dell'analisi.",
      guideStep3Title: "Come interpretare il report?",
      guideStep3Body: "Una volta generato, il report mostra una mappa a colori che divide l'azienda in tre zone di produttività.",
      guideTip: "Suggerimento:",
      guideTipBody: "Inizia dalle zone arancioni — necessitano dei miglioramenti più urgenti. Studia le zone verdi per replicare le buone pratiche.",
      invalidGeojsonFile: "File GeoJSON non valido",
      invalidGeojsonFileDescription: "Il file selezionato non Ã¨ un GeoJSON valido. Controlla e riprova.",
      generateFailed: "Impossibile avviare la generazione del report. Riprova.",
      loadFailed: "Impossibile caricare il report. Riprova.",
      deleteConfirmTitle: "Elimina report",
      deleteConfirmMessage: "Sei sicuro di voler eliminare questo report? L'azione non puÃ² essere annullata.",
      deleted: "Report eliminato correttamente.",
      uploadFailed: "Caricamento file non riuscito. Riprova.",
    },

    // ---- Anomaly Detection ----
    anomalyDetection: {
      title: "Rilevamento anomalie",
      reportComparison: "Confronto report",
      listOfReports: "Elenco dei report",
      createNewReport: "Crea nuovo report",
      backToDashboard: "Torna alla dashboard",
      generateReport: "Genera report",
      cancel: "Annulla",
      back: "Indietro",
      deleteReport: "Elimina report",
      downloadReport: "Scarica report",
      compareReports: "Confronta report",
      aiReportGuide: "Guida al report IA",
      search: "Cerca",
      reportId: "ID report",
      farmAndFarmId: "Azienda e ID azienda",
      producerName: "Nome del produttore",
      dateOfReport: "Data del report",
      status: "Stato",
      statusCompleted: "Completato",
      statusGenerating: "In generazione",
      statusPartial: "Parziale",
      statusFailed: "Non riuscito",
      location: "Posizione",
      farm: "Azienda",
      zone: "Zona",
      actions: "Azioni",
      view: "Visualizza",
      delete: "Elimina",
      selectFarmGeofence: "Seleziona geofence azienda",
      selectFarmGeofenceHelp: "Seleziona un'azienda registrata, disegna il confine sulla mappa oppure carica un file GeoJSON.",
      selectFarmZone: "Seleziona azienda / zona",
      sourceFarmZone: "Azienda / zona",
      sourcePolygon: "Poligono",
      sourceCircle: "Cerchio",
      sourceGeojson: "GeoJSON",
      radiusM: "Raggio (m)",
      select: "Seleziona",
      uploadGeojsonFile: "Carica file GeoJSON",
      uploadGeojsonHelp: "Seleziona un file GeoJSON con la geofence e caricalo. VerrÃ  caricata una sola geofence alla volta, anche se il file ne contiene diverse.",
      selectAFile: "Seleziona un file",
      drawPolygon: "Disegna poligono",
      drawPolygonHelp: "Fai clic sulla mappa per aggiungere punti.",
      drawCircle: "Disegna cerchio",
      drawCircleHelp: "Fai clic sulla mappa per impostare il centro; imposta il raggio sotto o trascina il cerchio per ridimensionarlo.",
      detectAnomalies: "Rileva anomalie",
      detectAnomaliesHelp: "Dopo aver disegnato o caricato una geofence, seleziona la data di interesse per rilevare anomalie.",
      startDate: "Data di inizio",
      fetchingDates: "Recupero date disponibili...",
      noAvailableDates: "Non ci sono date satellitari disponibili per quest'area.",
      selectDateToGenerate: "Seleziona una data disponibile, poi genera il report.",
      numberOfHistoricalReports: "Numero di report storici",
      historicalReportsPlaceholder: "Inserisci qui",
      historicalReportsNote: "Aumentare questo numero consumerà crediti AI aggiuntivi per ogni immagine storica richiesta.",
      estimatedComputeCost: "Costo di calcolo stimato",
      totalCreditsRequired: "Crediti totali richiesti",
      creditsComingSoon: "Sistema di crediti in arrivo.",
      selectDate: "Seleziona data",
      reportDetails: "Dettagli del report",
      closestImageNote: "Le immagini satellitari per {requested} non erano disponibili. Abbiamo usato l'immagine disponibile più vicina.",
      generating: "Generazione del report...",
      generatingHelp: "Il report è in fase di generazione. Potrebbero volerci alcuni minuti.",
      partialWarning: "Alcune date non sono state generate per questo report.",
      failed: "Generazione del report non riuscita.",
      disclaimerTitle: "AVVISO",
      disclaimer: "Questo report generato da IA Ã¨ pensato come guida. Per una diagnosi accurata e raccomandazioni su misura, consigliamo di consultare un agronomo o un esperto agricolo qualificato.",
      greenAreas: "Aree verdi",
      greenAreasDesc: "Il vigore vegetativo attuale supera la media storica",
      yellowAreas: "Aree gialle",
      yellowAreasDesc: "Il vigore vegetativo attuale è in linea con la media storica",
      redAreas: "Aree rosse",
      redAreasDesc: "Aree con scarsa resa delle colture che richiedono attenzione o intervento immediato.",
      underperforming: "Sotto le prestazioni",
      outperforming: "Sopra le prestazioni",
      imageComparison: "Confronto report",
      sideComparison: "Confronto affiancato",
      sliderComparison: "Confronto con cursore",
      transparencyComparison: "Confronto trasparenza",
      transparencySlider: "Cursore trasparenza",
      notGeneratedPrompt: "Questo report non è ancora stato generato per la data selezionata. Generarlo ora?",
      generateNow: "Genera ora",
      feedback: "Feedback",
      doYouAgree: "Sei d'accordo con la previsione?",
      agree: "D'accordo",
      disagree: "In disaccordo",
      agreedWithPrediction: "D'accordo con la previsione",
      disagreedWithPrediction: "In disaccordo con la previsione",
      disagreeHelp: "Se non sei d'accordo con questo risultato, fornisci un feedback",
      addFeedback: "Aggiungi feedback",
      feedbackPlaceholder: "Inserisci qui",
      attachmentsOptional: "Allegati (opzionale)",
      attachments: "Allegati",
      download: "Scarica",
      attachmentsHelp: "Trascina qui immagini o video, oppure sfoglia i file. Formati supportati: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleziona i file da caricare",
      orDragAndDrop: "oppure trascina e rilascia qui",
      submit: "Invia",
      feedbackSubmitted: "Feedback inviato correttamente.",
      feedbackAlreadySubmitted: "Il feedback Ã¨ giÃ  stato inviato per questo report.",
      guideTitle: "Guida al rilevamento anomalie",
      guideStep: "Passo {current} di {total}",
      next: "Avanti",
      close: "Chiudi",
      guideStep1Title: "Cos'è il rilevamento anomalie?",
      guideStep1Body: "Il rilevamento anomalie confronta le prestazioni vegetative attuali del campo con la media storica per identificare aree sopra o sotto le aspettative.",
      guideStep2Title: "Come generare un report?",
      guideStep2Body: "Creare il report è facile:\n\n1. Seleziona l'azienda dal menu a discesa (se già registrata) oppure disegna/carica il confine.\n2. Scegli una data disponibile e genera il report.",
      guideStep3Title: "Come interpretare il report?",
      guideStep3Body: "Una volta generato, il report mostra una mappa di calore a colori basata sul confronto tra vigore attuale e storico.",
      guideTip: "Suggerimento:",
      guideTipBody: "Confronto date: il report fornisce mappe di calore per più date, consentendo di seguire i cambiamenti nel tempo.",
      invalidGeojsonFile: "File GeoJSON non valido",
      invalidGeojsonFileDescription: "Il file selezionato non Ã¨ un GeoJSON valido. Controlla e riprova.",
      geofenceRequired: "Seleziona un'azienda/zona, disegna una geofence o carica un GeoJSON.",
      dateRequired: "Seleziona una data disponibile.",
      generateFailed: "Impossibile avviare la generazione del report. Riprova.",
      loadFailed: "Impossibile caricare il report. Riprova.",
      datesFailed: "Impossibile recuperare le date disponibili. Riprova.",
      deleteConfirmTitle: "Elimina report",
      deleteConfirmMessage: "Sei sicuro di voler eliminare questo report? L'azione non puÃ² essere annullata.",
      deleted: "Report eliminato correttamente.",
      uploadFailed: "Caricamento file non riuscito. Riprova.",
    },

        yieldPredictionDesign: {
      disclaimerTitle: "AVVERTENZA",
      disclaimerIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
      disclaimer1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
      disclaimer2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
      disclaimer3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
      disclaimer4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
      // feedback (shared FeedbackDisplay / FeedbackDialog)

      feedback: "Feedback",
      doYouAgree: "Sei d'accordo con la previsione?",
      agree: "D'accordo",
      disagree: "In disaccordo",
      agreedWithPrediction: "D'accordo con la previsione",
      disagreedWithPrediction: "In disaccordo con la previsione",
      disagreeHelp: "Se non sei d'accordo con questo risultato, fornisci un feedback",
      addFeedback: "Aggiungi feedback",
      feedbackPlaceholder: "Inserisci qui",
      attachmentsOptional: "Allegati (opzionale)",
      attachments: "Allegati",
      download: "Scarica",
      attachmentsHelp: "Trascina qui immagini o video, oppure sfoglia i file. Formati supportati: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleziona i file da caricare",
      orDragAndDrop: "oppure trascina e rilascia qui",
      submit: "Invia",
      feedbackSubmitted: "Feedback inviato correttamente.",
      feedbackAlreadySubmitted: "Il feedback è già stato inviato per questo report.",
      uploadFailed: "Caricamento file non riuscito. Riprova.",
    },

landSuitabilityDesign: {
      reportDetails: "Dettagli del report",
      greenAreas: "Aree verdi",
      greenAreasDesc: "Aree classificate come altamente idonee per la coltura selezionata",
      yellowAreas: "Aree gialle",
      yellowAreasDesc: "Aree con idoneità moderata che potrebbero richiedere attenzione",
      redAreas: "Aree rosse",
      redAreasDesc: "Aree classificate come non idonee e che probabilmente richiedono un intervento",
      underperforming: "Sotto le prestazioni",
      outperforming: "Sopra le prestazioni",
      feedback: "Feedback",
      doYouAgree: "Sei d'accordo con la previsione?",
      agree: "D'accordo",
      disagree: "In disaccordo",
      agreedWithPrediction: "D'accordo con la previsione",
      disagreedWithPrediction: "In disaccordo con la previsione",
      disagreeHelp: "Se non sei d'accordo con questo risultato, fornisci un feedback",
      addFeedback: "Aggiungi feedback",
      feedbackPlaceholder: "Inserisci qui",
      attachmentsOptional: "Allegati (opzionale)",
      attachments: "Allegati",
      download: "Scarica",
      attachmentsHelp: "Trascina qui immagini o video, oppure sfoglia i file. Formati supportati: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleziona i file da caricare",
      orDragAndDrop: "oppure trascina e rilascia qui",
      submit: "Invia",
      feedbackSubmitted: "Feedback inviato correttamente.",
      feedbackAlreadySubmitted: "Il feedback è già stato inviato per questo report.",
      uploadFailed: "Caricamento file non riuscito. Riprova.",
    },
    cropProgression: {
      title: "Analisi del vigore della vegetazione",
      listOfReports: "Elenco dei report",
      createNewReport: "Crea nuovo report",
      backToDashboard: "Torna alla dashboard",
      generateReport: "Genera report",
      cancel: "Annulla",
      back: "Indietro",
      deleteReport: "Elimina report",
      downloadReport: "Scarica report",
      compareImages: "Confronta immagini",
      aiReportGuide: "Guida al report IA",
      search: "Cerca",
      reportId: "ID report",
      farmAndFarmId: "Azienda e ID azienda",
      producerName: "Nome del produttore",
      dateOfReport: "Data del report",
      selectedDate: "Data del report",
      status: "Stato",
      statusCompleted: "Completato",
      statusGenerating: "In generazione",
      statusPartial: "Parziale",
      statusFailed: "Non riuscito",
      location: "Posizione",
      farm: "Azienda",
      zone: "Zona",
      actions: "Azioni",
      view: "Visualizza",
      delete: "Elimina",
      selectFarmGeofence: "Seleziona geofence aziendale",
      selectFarmGeofenceHelp: "Seleziona un'azienda registrata, disegna il confine sulla mappa o carica un GeoJSON per analizzare l'area.",
      point: "Punto",
      geofence: "Geofence",
      selectFarmZone: "Seleziona azienda / zona",
      sourceFarmZone: "Azienda / zona",
      sourcePolygon: "Poligono",
      sourceCircle: "Cerchio",
      sourceGeojson: "GeoJSON",
      mapView: "Vista mappa",
      latitude: "Latitudine",
      longitude: "Longitudine",
      radiusKm: "Raggio (km)",
      radiusM: "Raggio (m)",
      enterHere: "Inserisci qui",
      select: "Seleziona",
      uploadGeojsonFile: "Carica file GeoJSON",
      uploadGeojsonHelp: "Seleziona un file GeoJSON con la geofence e caricalo. Verrà caricata una sola geofence alla volta, anche se il file ne contiene diverse.",
      selectAFile: "Seleziona un file",
      drawPolygon: "Disegna poligono",
      drawPolygonHelp: "Fai clic sulla mappa per aggiungere punti.",
      drawCircle: "Disegna cerchio",
      drawCircleHelp: "Fai clic sulla mappa per impostare il centro; imposta il raggio sotto o trascina il cerchio per ridimensionarlo.",
      clearDrawing: "Cancella",
      searchLocation: "Cerca posizione",
      closePolygonHint: "Fai clic sul primo punto per chiudere l'area",
      unnamedFarm: "Azienda #{id}",
      unnamedZone: "Zona #{id}",
      selectDate: "Seleziona data",
      availableDates: "Date disponibili",
      fetchingDates: "Recupero date disponibili...",
      noAvailableDates: "Nessuna data satellitare disponibile per quest'area.",
      selectDateToGenerate: "Seleziona una data disponibile, poi genera il report.",
      estimatedComputeCost: "Costo di calcolo stimato",
      totalCreditsRequired: "Crediti totali richiesti",
      creditsAvailable: "Crediti disponibili",
      creditsSufficient: "Crediti sufficienti per la generazione del report IA",
      reportType: "Tipo di report",
      selectReportType: "Seleziona tipo di report",
      chooseIndexHelp: "Scegli un indice satellitare per analizzare crescita, umidità o nutrienti nel tempo.",
      scale: "Scala",
      generating: "Generazione report...",
      generatingHelp: "Il report è in generazione. Potrebbero servire alcuni minuti.",
      partialWarning: "Alcuni indici non sono stati generati per questa data.",
      failed: "Generazione del report non riuscita.",
      valuesCloseToOne: "I valori vicini a 1 indicano vegetazione più sana",
      disclaimerTitle: "AVVISO",
      disclaimer: "Questo report generato da IA è pensato come guida. Per una diagnosi accurata e raccomandazioni su misura, consigliamo di consultare un agronomo o un esperto agricolo qualificato.",
      indexNDVI: "Salute delle colture (NDVI)",
      indexMSAVI: "Crescita vegetativa precoce (MSAVI)",
      indexLSWI: "Contenuto di umidità (LSWI)",
      indexRECI: "Stima del livello di nutrienti (RECI)",
      indexNDRE: "Verdore e densità della chioma (NDRE)",
      reportComparison: "Confronto report vigore della vegetazione",
      imageComparison: "Confronto immagini",
      sideComparison: "Confronto affiancato",
      sliderComparison: "Confronto con cursore",
      transparencyComparison: "Confronto trasparenza",
      transparencySlider: "Cursore trasparenza",
      notGeneratedPrompt: "Questo report non è ancora stato generato per la data selezionata. Generarlo ora?",
      generateNow: "Genera ora",
      feedback: "Feedback",
      doYouAgree: "Sei d'accordo con la previsione?",
      agree: "D'accordo",
      disagree: "In disaccordo",
      agreedWithPrediction: "D'accordo con la previsione",
      disagreedWithPrediction: "In disaccordo con la previsione",
      disagreeHelp: "Se non sei d'accordo con questo risultato, fornisci il tuo feedback",
      addFeedback: "Aggiungi feedback",
      feedbackPlaceholder: "Inserisci qui",
      attachmentsOptional: "Allegati (opzionale)",
      attachments: "Allegati",
      download: "Scarica",
      attachmentsHelp: "Trascina qui immagini o video, oppure sfoglia i file. Formati supportati: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleziona i file da caricare",
      orDragAndDrop: "oppure trascina e rilascia qui",
      submit: "Invia",
      feedbackSubmitted: "Feedback inviato correttamente.",
      feedbackAlreadySubmitted: "Il feedback è già stato inviato per questo report.",
      guideTitle: "Guida all'analisi del vigore della vegetazione",
      guideStep: "Passo {current} di {total}",
      next: "Avanti",
      close: "Chiudi",
      guideStep1Title: "Cos'è il report di analisi del vigore della vegetazione?",
      guideStep1Body: "Questa analisi aiuta a individuare aree dell'azienda con basso vigore vegetativo per intervenire tempestivamente. Il report usa immagini satellitari per mostrare quanto sono sane le colture in un momento specifico.\n\nLa heatmap mostra quali parti dell'azienda possono richiedere attenzione. Confrontando immagini di date diverse puoi seguire se le colture migliorano o peggiorano.",
      guideStep2Title: "Come generare un report?",
      guideStep2Body: "Creare il report è semplice:\n\n1. Seleziona l'azienda dal menu (se già registrata). Il confine apparirà sulla mappa. Oppure disegna il confine manualmente se non è ancora registrata.\n2. Scegli una data: la data per cui vuoi vedere i dati di vigore.\n3. Fai clic su \"Genera report\" per vedere l'analisi.",
      guideStep3Title: "Come interpretare il report?",
      guideStep3Body: "Una volta generato, vedrai una heatmap dell'azienda con colori verde, giallo e rosso.\n\nVerde = Alto vigore vegetativo\nGiallo/Rosso = Vigore inferiore → può richiedere attenzione\n\nIl basso vigore può dipendere da raccolta, suolo povero, parassiti o meteo recente.",
      guideTip: "Suggerimento:",
      guideTipBody: "Usa il selettore date sotto la heatmap per vedere più report e seguire i cambiamenti nella salute delle colture. Puoi salvare, scaricare o eliminare i report in qualsiasi momento.",
      additionalReportTypes: "Tipi di report aggiuntivi disponibili:",
      invalidGeojsonFile: "File GeoJSON non valido",
      invalidGeojsonFileDescription: "Il file selezionato non è un GeoJSON valido. Controlla e riprova.",
      geofenceRequired: "Seleziona un'azienda/zona, disegna una geofence o carica un GeoJSON.",
      dateRequired: "Seleziona una data disponibile.",
      generateFailed: "Impossibile avviare la generazione del report. Riprova.",
      loadFailed: "Impossibile caricare il report. Riprova.",
      datesFailed: "Impossibile recuperare le date disponibili. Riprova.",
      deleteConfirmTitle: "Elimina report",
      deleteConfirmMessage: "Sei sicuro di voler eliminare questo report? L'azione non può essere annullata.",
      deleted: "Report eliminato correttamente.",
      uploadFailed: "Caricamento file non riuscito. Riprova.",
    },
    aiClient: {
      credits: "Crediti",
      cancel: "Annulla",
      save: "Salva",
      back: "Indietro",
      close: "Chiudi",
      search: "Cerca",
      makeSelection: "Effettua una selezione",
      errorTitle: "Errore",
      successTitle: "Operazione riuscita",
      loadFailed: "Impossibile caricare i dati. Riprova.",
      saveFailed: "Impossibile salvare. Riprova.",
      saved: "Impostazioni salvate correttamente.",
      rt_vegetation_vigor: "Vigore della vegetazione",
      rt_farm_productivity: "Produttività dell'azienda",
      rt_anomaly_detection: "Rilevamento anomalie",
      rt_yield_prediction: "Previsione della resa",
      rt_disease_detection: "Rilevamento malattie",
      rt_land_suitability: "Idoneità del terreno",
      dashTitle: "Dashboard report IA",
      dashGuide: "Guida della dashboard",
      builders: "Generatori di report IA",
      distributionTitle: "Distribuzione per tipo di report",
      colReportType: "Tipo di report",
      colReportsGenerated: "Report generati",
      recentTitle: "Report IA recenti",
      noRecent: "Nessun report generato ancora.",
      noDistribution: "Nessuna attività di report ancora.",
      na: "N/D",
      bVegetationVigor: "Analisi del vigore della vegetazione",
      bFarmProductivity: "Analisi della produttività aziendale",
      bAnomalies: "Rilevamento anomalie",
      bYield: "Previsione della resa",
      bDisease: "Rilevamento malattie",
      bLand: "Idoneità del terreno",
      insightsTitle: "Approfondimenti e analisi IA",
      iVegHealth: "Salute media della vegetazione",
      iDisease: "Malattie rilevate questo mese",
      iAnomalies: "Anomalie questo mese",
      iYieldTrend: "Tendenza di resa prevista",
      creditsAvailableLabel: "Disponibili",
      totalCredits: "Crediti totali:",
      creditsUsedLabel: "Crediti usati:",
      topUp: "Ricarica crediti",
      topUpInfo: "Contatta l'amministratore per ricaricare i crediti.",
      creditsHistory: "Cronologia crediti",
      manageBtn: "Gestisci report IA e crediti",
      manageTitle: "Gestisci report IA e crediti",
      usageLogBtn: "Registro utilizzo crediti",
      cardAvailable: "Crediti disponibili",
      cardTotal: "Crediti totali",
      cardUsed: "Crediti usati",
      refreshesOn: "Si rinnova il",
      assignedOn: "Assegnato il",
      distBudgetTitle: "Distribuzione e budget dei report IA",
      distBudgetHelp: "Configura l'accesso ai report IA per unioni, fabbriche e agricoltori. Assegna budget di crediti specifici a ciascun livello per gestire in modo efficiente il consumo di risorse della cooperativa.",
      group_cooperative: "Cooperativa",
      group_buying_station: "Stazione di acquisto",
      group_farmer: "Agricoltore",
      monthlyCredits: "Crediti mensili",
      aiReports: "Report IA",
      enabled: "Abilitato",
      disabled: "Disabilitato",
      overAllocation: "Le assegnazioni del gruppo superano il budget di crediti della cooperativa.",
      usageLogTitle: "Registro utilizzo crediti",
      filterCooperative: "Cooperativa",
      filterReport: "Report IA",
      colDateTime: "Data e ora",
      colEntity: "Entità",
      colAiReport: "Report IA",
      colCreditsUsed: "Crediti usati",
      colBalance: "Saldo",
      historyTitle: "Cronologia crediti",
      historyDesc: "Una panoramica delle assegnazioni di crediti rispetto al consumo di questa cooperativa. Usa questo riepilogo per monitorare le tendenze mensili di utilizzo e i cicli di fatturazione.",
      coopLabel: "Cooperativa",
      colMonth: "Mese",
      colCreditsAssigned: "Crediti assegnati",
      colClosingBalance: "Saldo di chiusura",
      noHistory: "Nessuna cronologia crediti ancora.",
      guideTitle: "Guida alla dashboard report IA di Dimitra",
      guideStep: "Passo",
      guideOf: "di",
      guideClose: "Chiudi",
      guideSkip: "Salta",
      guideNext: "Avanti",
      guideBack: "Indietro",
      guideDone: "Chiudi",
      g1Title: "Panoramica della dashboard",
      g1Intro: "Benvenuto nel tuo hub di approfondimenti IA. Questa guida ti aiuterà a interpretare la mappa, gestire i crediti e usare i modelli IA.",
      g1Points: [
        "Comprendi le informazioni della mappa: Usa i filtri sulla mappa per visualizzare province e regioni specifiche. La heatmap offre una vista immediata a colori delle prestazioni delle aziende nella cooperativa, con chiavi per indicatori Alto/Medio/Basso.",
        "Monitora i crediti: I crediti attualmente disponibili sono mostrati in alto a destra. Assicurati di avere saldo sufficiente prima di generare report di grandi dimensioni.",
      ],
      g2Title: "Comprendere i report IA",
      g2Intro: "La dashboard offre accesso a modelli IA specializzati. Ogni report analizza aspetti diversi dei tuoi dati agricoli.",
      g2Points: [
        "Vigore della vegetazione: Valuta la salute complessiva delle colture e individua le aree che richiedono attenzione.",
        "Produttività aziendale: Analizza le tendenze storiche di produttività per ottimizzare il potenziale di resa.",
        "Rilevamento anomalie: Individua pattern irregolari sul campo che possono indicare stress o minacce esterne.",
        "Previsione della resa: Prevedi i risultati del raccolto in base ai dati di crescita attuali.",
        "Rilevamento malattie: Usa immagini delle piante per identificare immediatamente malattie specifiche.",
      ],
      g3Title: "Come funzionano i crediti",
      g3Intro: "Dimitra usa un sistema basato sui crediti per gestire il consumo di risorse IA. I crediti fungono da valuta per generare report.",
      g3Points: [
        "Assegnazione: Alla cooperativa viene assegnato un saldo mensile dall'amministratore.",
        "Consumo: Ogni volta che generi un report, i crediti vengono detratti dal saldo disponibile.",
        "Visibilità: Puoi tracciare ogni detrazione nel registro crediti dedicato.",
      ],
      g4Title: "Monitoraggio dell'uso e cronologia crediti",
      g4Intro: "Mantieni il controllo del budget seguendo da vicino la cronologia dei crediti.",
      g4Points: [
        "Saldo disponibile: Sempre visibile nella scheda in alto a destra. Controlla la data di rinnovo per sapere quando arriva la prossima assegnazione.",
        "Registro utilizzo: Fai clic su [Cronologia crediti] per vedere nel dettaglio quale report è stato generato, quando e da quale entità (cooperativa, unione, fabbrica o agricoltore).",
        "Gestione: Se i crediti stanno finendo, usa il pulsante [Gestisci report IA e crediti] per regolare i budget a livello di entità o contatta l'amministratore per una ricarica aggiuntiva.",
      ],
    },
  },
};
